module.exports = __webpack_public_path__ + "static/media/prickig.201530aa.mp3";